import { NormalButton } from "../Button";
import { CancelButton } from "../Button/CancelButton/CancelButton";
import { Modal } from "../Modal";
import { Typography } from "../Typography";
import styles from "./ConfirmationModal.module.scss";

type TConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  content: string;
  isDisabled?: boolean;
  confirmButtonText?: string;
  cancelButtonText?: string;
  dangerConfirm?: boolean;
  mobileBreakpoint?: number;
};

export function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  content,
  isDisabled,
  confirmButtonText,
  cancelButtonText,
  dangerConfirm = false,
  mobileBreakpoint
}: TConfirmationModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      width="454px"
      minHeight="240px"
      mobileBreakpoint={mobileBreakpoint}
    >
      <div className={styles.contentContainer}>
        <Typography variant="body-2">{content}</Typography>
      </div>
      <div className={styles.buttonsContainer}>
        <CancelButton onClick={onClose} size="large">
          {cancelButtonText || "Cancel"}
        </CancelButton>
        <NormalButton
          onClick={onConfirm}
          size="large"
          isDisabled={isDisabled}
          className={dangerConfirm && !isDisabled ? styles.danger : ""}
        >
          {confirmButtonText || "Confirm"}
        </NormalButton>
      </div>
    </Modal>
  );
}
